var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModeChange = function SvgModeChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mode_change_svg__st0",
    d: "M5.9 6.8H2.4c-.4 0-.9-.3-.9-.9V2.4c0-.5.4-.9.9-.9h3.5c.5 0 .9.4.9.9v3.5c0 .5-.4.9-.9.9zM21.6 6.8H9.8c-.5 0-.9-.3-.9-.9V2.4c0-.5.3-.9.9-.9h11.8c.5 0 .9.4.9.9v3.5c0 .5-.4.9-.9.9zM5.9 22.5H2.4c-.5 0-.9-.4-.9-.9v-3.5c0-.5.4-.9.9-.9h3.5c.5 0 .9.4.9.9v3.5c0 .5-.4.9-.9.9zM21.6 22.5H9.8c-.5 0-.9-.4-.9-.9v-3.5c0-.5.3-.9.9-.9h11.8c.5 0 .9.4.9.9v3.5c0 .5-.4.9-.9.9zM5.9 14.6H2.4c-.5 0-.9-.3-.9-.9v-3.5c0-.5.4-.9.9-.9h3.5c.5 0 .9.3.9.9v3.5c0 .6-.4.9-.9.9zM21.6 14.6H9.8c-.5 0-.9-.3-.9-.9v-3.5c0-.5.3-.9.9-.9h11.8c.5 0 .9.3.9.9v3.5c0 .6-.4.9-.9.9z"
  })));
};
export default SvgModeChange;